import React from 'react'

import NavButton from './navButton'
import IconClose from '../../../../shared/components/icons/close'

import styles from './buttons.module.css'

const CloseButton = ({ itemId }) => (
  <NavButton
    keyName="Escape"
    itemId={itemId}
    className={styles.iconCloseWrapper}
  >
    <IconClose className={styles.iconClose} />
  </NavButton>
)

export default CloseButton
